import { MS_UUID } from '../constants'

export const getFilterPayload = (filterIds = []) => {
  // if (!filterIds?.length) return {}
  return { filter: ['in', ['get', MS_UUID], ['literal', filterIds]] }
}
